<div>

    <div class="buttons" data-qa="settings-kundenbetreuer-page-button">
        <button matButton="filled" class="actionbutton" (click)="createKundenbetreuer()">
            <mat-icon>add</mat-icon>
            Neuer Kundenbetreuer
        </button>
    </div>

    <table [dataSource]="kundenbetreuerList"
           mat-table
           class="kundenbetreuerTable"
           data-qa="settings-kundenbetreuer-page-table">

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let kundenbetreuer; columns: columnsToDisplay"
            role="link"
            tabindex="0"
            (click)="openKundenbetreuer(kundenbetreuer)"
            (keydown.enter)="openKundenbetreuer(kundenbetreuer)"
        ></tr>

        <ng-container matColumnDef="vorname">
            <th mat-header-cell *matHeaderCellDef>Vorname</th>
            <td mat-cell *matCellDef="let kundenbetreuer;">{{ kundenbetreuer.vorname }}</td>
        </ng-container>

        <ng-container matColumnDef="nachname">
            <th mat-header-cell *matHeaderCellDef>Nachname</th>
            <td mat-cell *matCellDef="let kundenbetreuer;">{{ kundenbetreuer.nachname }}</td>
        </ng-container>

    </table>
</div>
